export default "__VITE_ASSET__ceec5127__"